import { render } from "./ThankView.vue?vue&type=template&id=39c3f74d"
import script from "./ThankView.vue?vue&type=script&lang=js"
export * from "./ThankView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__